import { render, staticRenderFns } from "./ResearchPageDescription.vue?vue&type=template&id=9872e0cc&"
import script from "./ResearchPageDescription.vue?vue&type=script&lang=js&"
export * from "./ResearchPageDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9872e0cc')) {
      api.createRecord('9872e0cc', component.options)
    } else {
      api.reload('9872e0cc', component.options)
    }
    module.hot.accept("./ResearchPageDescription.vue?vue&type=template&id=9872e0cc&", function () {
      api.rerender('9872e0cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchPageDescription.vue"
export default component.exports